import React from 'react';
import dayjs from 'dayjs';
import { ListItem, Box, Grid, IconButton, Chip, Typography } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import DateRangeIcon from '@material-ui/icons/DateRange';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import FlagIcon from '@material-ui/icons/Flag';

function WorklineListItem({ line, projectLine, onClick }) {
    // If a line is provided, default to its properties
    let createdOn, product, project;
    if (line) {
        createdOn = line.createdOn;
        projectLine = line.projectLine;
    }
    // If a projectLine is provided (either directly or through a line), extract its properties
    if (projectLine) {
        product = projectLine.product;
        project = projectLine.project;
    }

    return (
        <Box display='flex'>
            <ListItem style={{ borderLeft: projectLine?.checkIn ? `6px solid ${green[400]}` : '6px solid #b0b0b0', paddingRight: 0 }}>
                <Grid container style={{ justifyContent: 'space-between' }}>
                    <Grid item xs={11} container direction='column' spacing={1} >
                        <Grid item container alignItems='flex-start'>
                            <Grid item xs={8}>
                                <Box display='flex' alignItems="flex-start">
                                    <LocationOnIcon fontSize='small' />
                                    <Typography variant='body1' style={{ paddingLeft: '4px' }}>{project?.address?.name ?? projectLine?.name ?? 'N/A'}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box display='flex' alignItems="center">
                                    <DateRangeIcon fontSize='small'  />
                                    <Typography variant='body2' style={{ paddingLeft: '4px' }}>{createdOn ? dayjs(createdOn).format('DD.MM.YY') : 'N/A'}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item container spacing={1} style={{ marginLeft: 2}}>
                            <Grid item>
                                <Chip
                                    icon={<FlagIcon fontSize='inherit' />}
                                    size='small'
                                    style={{ padding: 2 }}
                                    label={project?.address?.postalCode ?? 'N/A'}
                                />
                            </Grid>
                            <Grid item>
                                <Chip
                                    size='small'
                                    style={{ padding: 2 }}
                                    label={project?.serviceType?.name ?? product?.name ?? 'N/A'}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={1} container justifyContent='flex-end' alignItems='center'>
                        <IconButton size='small' edge="end" onClick={onClick}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </ListItem>
        </Box>
    )
}

export default WorklineListItem;